var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { OrganizationsStateModel } from './organizations.state.model';
import { SelectOrganization, SetOrganizations, SelectCollection, GetCollectionsSuccess, GetCollections, JoinOrganization, JoinOrganizationSuccess, JoinOrganizationFail, ResetOrganizations } from './organizations.actions';
import { OrganizationsService } from '../organizations.service';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';
import { PublishService } from 'src/app/publish/publish.service';
import { SetPublishWidgetURL } from 'src/app/publish/state/publish.actions';
var initialState = {};
var OrganizationsState = /** @class */ (function () {
    function OrganizationsState(organizationsService, publishService) {
        this.organizationsService = organizationsService;
        this.publishService = publishService;
    }
    /**
     * Selectors
     */
    OrganizationsState.getOrganizations = function (state) {
        return state.organizations;
    };
    OrganizationsState.getOrganization = function (state) {
        return state.organization;
    };
    OrganizationsState.getSelectedOrganization = function (state) {
        return state.selectedOrganization;
    };
    OrganizationsState.getCollections = function (state) {
        return state.collections;
    };
    OrganizationsState.getSelectedCollection = function (state) {
        return state.selectedCollection;
    };
    OrganizationsState.getWidgetURL = function (state) {
        return state.widgetURL;
    };
    OrganizationsState.getWidgetOptions = function (state) {
        return state.widgetOptions;
    };
    OrganizationsState.getAppFeatures = function (state) {
        return state.appFeatures;
    };
    /**
     * Actions
     */
    OrganizationsState.prototype.selectOrganization = function (context, action) {
        var organization = action.organization;
        context.patchState({
            selectedOrganization: organization,
            selectedCollection: null
        });
    };
    OrganizationsState.prototype.setOrganizations = function (context, action) {
        var organizations = action.organizations || [];
        var organization = organizations[0];
        var widgetURL;
        var widgetOptions = null;
        var appFeatures = __assign({}, context.getState().appFeatures);
        // read organization widget settings
        if (organization && organization.group_attributes) {
            var attributes = organization.group_attributes;
            // set org default widget url
            var widgetURLAttribute = this.organizationsService.getOrganizationAttribute(attributes, 'widget_settings', 'widget_custom_url_path');
            if (widgetURLAttribute && widgetURLAttribute.value) {
                widgetURL = widgetURLAttribute.value;
            }
            // set org default options
            var widgetOptionsAttribute = this.organizationsService.getOrganizationAttribute(attributes, 'widget_settings', 'widget_url_params');
            if (widgetOptionsAttribute && widgetOptionsAttribute.value) {
                widgetOptions = this.publishService.extendWidgetOptions(new WidgetOptions(), widgetOptionsAttribute.value);
            }
            // set org app features
            var appFeaturesAttribute = this.organizationsService.getOrganizationAttribute(attributes, 'app_settings', 'web_app_features');
            if (appFeaturesAttribute) {
                appFeatures = __assign({}, appFeatures, appFeaturesAttribute.value);
            }
        }
        context.patchState({
            organization: organization,
            organizations: organizations,
            widgetURL: widgetURL,
            widgetOptions: widgetOptions,
            appFeatures: appFeatures
        });
        // set default widget
        context.dispatch(new SetPublishWidgetURL(widgetURL));
    };
    OrganizationsState.prototype.joinOrganization = function (context, _a) {
        var organization = _a.organization;
        this.organizationsService.addUserToOrganization(organization.eid)
            .subscribe(function () { return context.dispatch(new JoinOrganizationSuccess(organization)); }, function (err) { return context.dispatch(new JoinOrganizationFail(organization)); });
    };
    OrganizationsState.prototype.getCollections = function (context, action) {
        this.organizationsService.getCollections(action.organizationId)
            .subscribe(function (collections) {
            context.dispatch(new GetCollectionsSuccess(collections));
        });
    };
    OrganizationsState.prototype.getCollectionsSuccess = function (context, action) {
        context.patchState({
            collections: action.collections
        });
    };
    OrganizationsState.prototype.selectCollection = function (context, action) {
        var _a = context.getState(), organization = _a.organization, selectedOrganization = _a.selectedOrganization;
        var collection = action.collection;
        context.patchState({
            // ensure organization selected
            selectedOrganization: selectedOrganization || organization,
            selectedCollection: collection
        });
    };
    OrganizationsState.prototype.resetOrganizations = function (context, action) {
        context.setState(initialState);
    };
    __decorate([
        Action(SelectOrganization),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectOrganization]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "selectOrganization", null);
    __decorate([
        Action(SetOrganizations),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetOrganizations]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "setOrganizations", null);
    __decorate([
        Action(JoinOrganization),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, JoinOrganization]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "joinOrganization", null);
    __decorate([
        Action(GetCollections),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetCollections]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "getCollections", null);
    __decorate([
        Action(GetCollectionsSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetCollectionsSuccess]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "getCollectionsSuccess", null);
    __decorate([
        Action(SelectCollection),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectCollection]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "selectCollection", null);
    __decorate([
        Action(ResetOrganizations),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetOrganizations]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState.prototype, "resetOrganizations", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getOrganizations", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getOrganization", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getSelectedOrganization", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getCollections", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getSelectedCollection", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getWidgetURL", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getWidgetOptions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OrganizationsStateModel]),
        __metadata("design:returntype", void 0)
    ], OrganizationsState, "getAppFeatures", null);
    OrganizationsState = __decorate([
        State({
            name: 'organizations',
            defaults: {}
        }),
        __metadata("design:paramtypes", [OrganizationsService,
            PublishService])
    ], OrganizationsState);
    return OrganizationsState;
}());
export { OrganizationsState };
